/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState_main = [];

const truckingRateUpdateSlice = createSlice({
    name: 'truckingRateUpdateForm',
    initialState: initialState_main,
    reducers: {
        setFormData: (state, action) => {
            return action.payload;
        },
        setRateUpdateData: (state, action) => {
            const { id, newData } = action.payload;
            return state.map((item) => {
                if (item.id === id) {
                    return { ...item, ...newData };
                }
                return item;
            });
        },
        addRate: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteRate: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((item) => item.id !== idToDelete);
        },
    },
});

export const { setFormData, setRateUpdateData, addRate, deleteRate } = truckingRateUpdateSlice.actions;
export default truckingRateUpdateSlice.reducer;
